import { css } from '@emotion/css';

export const styles = {
  footer: css`
    flex-shrink: 0;

    && {
      justify-content: center;
      align-items: center;
    }
  `,
  body: css`
    overscroll-behavior: contain;
  `,
  hero: css`
    height: 320px;

    @media (max-width: 668px) {
      height: 290px;
    }
  `,
  content: css`
    max-width: 610px;
  `,
  description: css`
    @media (min-width: 669px) {
      font-size: var(--size-heading-xsmall);
    }
  `,
  details: css`
    border-radius: var(--border-radius-400);
    overflow-wrap: anywhere;
  `,
  muted: css`
    color: var(--color-text-weak);
  `,
  logo: css`
    width: 140px;
    max-width: 100%;
    height: auto;
  `,
};
